import { createAction } from '@reduxjs/toolkit'

import type { TAttributeOptionDto } from '@homepal/api-contract'

// tryGetAllAttributeOptions
export const getAllSuccess = createAction<TAttributeOptionDto[]>(
  'get_attribute_options_success'
)
